import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class LogService extends ApiService {
  public getLogs(data: any){
    return this.post(CONSTANTS.API.LOG.GET_LOGS, data);
  }
}
